// Which tasks are findings.
//
// A finding is a task opened FROM another task: the agent found something
// outside its scope and wrote it down instead of fixing it. Core marks it with
// `origin_task_id` — the task it came out of — when it is created, and never
// clears it. So the mark survives authorization, delivery and closing: a
// finding that is being worked is still a finding.
//
// The list rows carry `origin_task_id`, so this needs no request.

export function isFinding(task) {
    return task?.origin_task_id != null;
}

// Splits a set of rows into what is shown and how many findings were set aside.
// With `show` on, nothing is hidden.
export function splitFindings(rows, show) {
    const list = Array.isArray(rows) ? rows : [];
    if (show) return { visible: list, hidden: 0 };
    const visible = list.filter(task => !isFinding(task));
    return { visible, hidden: list.length - visible.length };
}

// The number a column should show next to its title.
//
// EXACT WHEN EVERYTHING IS LOADED: if the column fetched all its rows, the
// hidden findings are simply subtracted. When it fetched a page of a larger
// set, the findings outside that page cannot be counted without asking Core
// for them, so the server's total is kept and `exact` says it may include some.
export function visibleCount({ total, loaded, hidden }) {
    const complete = loaded >= total;
    return complete
        ? { count: Math.max(0, total - hidden), exact: true }
        : { count: total, exact: hidden === 0 };
}
